<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <div v-if="detailInfo != null">
          <div class="prediction">
            <div class="predictionBox">
              <div class="head flex flex-pack-justify flex-align-center">
                <div class="flex flex-align-center">
                  <i class="divergenceIcon" />
                  <div class="title">Divergence Predicted O/U Results</div>
                </div>
                <i class="queryIcon" @click="showPopup()"/>
              </div>
              <div class="resultsBox">
                <div class="teamBox flex flex-align-center" :class="(match.state == 4 && detailInfo.ouModel.baseInfo.ouHit == 1) ? 'endHit' : (match.state == 4 && detailInfo.ouModel.baseInfo.ouHit != 1) ? 'endNoHit' : ''">
                  <div class="teamName">{{detailInfo.ouModel.overunderRes.predict == 1 ? 'Over' : 'Under'}} {{ detailInfo.ouModel.overunderRes.score }} {{ detailInfo.ouModel.overunderRes.predict > 1 ? 'Goals' : 'Goal' }}</div>
                  <i v-if="detailInfo.ouModel.baseInfo.ouHit == 1" class="active"/>
                </div>
                <div class="updataTime"><span @click="changePup('divergence')">{{getGameTime(detailInfo.ouModel.updateTime,'dd MM ,HH:mm')}} Updated</span></div>
              </div>
            </div>
          </div>
          <div class="logged" style="clear: both" v-if="isLogin == true || match.state == 4">
            <!-- OVER/UNDER -->
            <div class="module" v-if="detailInfo.ouModel.hasOwnProperty('overunderRes')">
              <div class="title">Goals Over/Under Prediction</div>
              <div class="box">
                <ul class="flex">
                  <li class="flex1">
                    <div class="head">Options</div>
                    <div class="body">Over</div>
                    <div class="body">Push</div>
                    <div class="body">Under</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Probability</div>
                    <div class="body">{{detailInfo.ouModel.overunderRes.overRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.ouModel.overunderRes.evenRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.ouModel.overunderRes.underRes || '&nbsp;'}}</div>
                  </li>
                  
                  <li class="flex1">
                    <div class="head">Pick</div>
                    <div class="suggestion" :class="(match.state == 4 && detailInfo.ouModel.baseInfo.ouHit == 1) ? 'endHit active' : (match.state == 4 && detailInfo.ouModel.baseInfo.ouHit != 1) ? 'endNoHit' : ''">
                      {{detailInfo.ouModel.overunderRes.predict == 1 ? 'Over' : detailInfo.ouModel.overunderRes.predict == 2 ? 'Under' : 'Push'}}
                      ({{detailInfo.ouModel.overunderRes.score}})
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- last 10 matches -->
            <div class="module" v-if="detailInfo.hasOwnProperty('ouModel') && detailInfo.ouModel.hasOwnProperty('last_10Goals') && JSON.stringify(detailInfo.ouModel.last_10Goals) != '{}'">
              <div class="title">Home/Away Statistics (Last 10 Matches)</div>
              <div class="box">
                <div class="container">
                  <div class="flex flex-pack-justify">
                    <div class="homeTile"><span>{{ detailInfo.match.homeTeam.shortName }}</span> Home</div>
                    <div class="awayTile"><span>{{ detailInfo.match.awayTeam.shortName }}</span> Away</div>
                  </div>
                  <!-- 进球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.home.goals}}</div>
                      <div class="name">Goals</div>
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.away.goals }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.ouModel.last_10Goals.home.goals) + Number(detailInfo.ouModel.last_10Goals.away.goals)), detailInfo.ouModel.last_10Goals.home.goals) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.ouModel.last_10Goals.home.goals) + Number(detailInfo.ouModel.last_10Goals.away.goals)), detailInfo.ouModel.last_10Goals.away.goals) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 失球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.home.loss }}</div>
                      <div class="name">Goals Conceded</div>
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.away.loss }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.ouModel.last_10Goals.home.loss) + Number(detailInfo.ouModel.last_10Goals.away.loss)), Number(detailInfo.ouModel.last_10Goals.home.loss)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.ouModel.last_10Goals.home.loss) + Number(detailInfo.ouModel.last_10Goals.away.loss)), Number(detailInfo.ouModel.last_10Goals.away.loss)) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 胜率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.home.winPct }}%</div>
                      <div class="name">Win Rate</div>
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.away.winPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.ouModel.last_10Goals.home.winPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.ouModel.last_10Goals.away.winPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 赢率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.home.handicapWinPct }}%</div>
                      <div class="name">Draw Rate</div>
                      <div class="val">{{ detailInfo.ouModel.last_10Goals.away.handicapWinPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.ouModel.last_10Goals.home.handicapWinPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.ouModel.last_10Goals.away.handicapWinPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 未登录 -->
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg1.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <div><img src="../../../assets/images/nodata.png" /></div>
          <div class="title">No data</div>
        </div>
      </div>
      <div class="rightBox flex1">
        <div class="title">Additional Matches</div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime)}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <van-popup class="tipPopup" v-model="tipPopupShow" :position="isWeb?'center':'bottom'" round  get-container="#app">
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">Divergence Prediction Instruction</p>
        <i class="popup_close" @click="tipPopupShow = !tipPopupShow"/>
      </div>
      <div class="popup_body">
        <div>
          <div class="popup_body_title">Our recommendation based on calculated probabilities and market trends.</div>
          <ul>
            <li>
              <div class="list_title">Goals Over/Under Result Prediction:</div>
              <div>
                <p>Provides a prediction of the number of goals scored for the 90-minute match, which may be over or under the specified number of goals (the line).</p>
                <p>As shown below, [Over 2.5 goal] means that the number of goals scored in the match may be more than 2.5 goals.</p>
              </div>
            </li>
            <li>
              <div class="list_title">Update Record:</div>
              <div>
                <p>Click on the "Updated" button in the bottom right corner to view the history of changes to all predictions. As our algorithm constantly adjusts to new data from bookmakers, the update time is a crucial indication.</p>
              </div>
            </li>
          </ul>
          <div class="img">
            <img v-if="isWeb == true" src="~@/assets/images/overunder_popup_divergence_pc.png" />
            <img v-if="isWeb == false" src="~@/assets/images/overunder_popup_divergence_mb.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'OverUnder',
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    match: {
      type: Object,
      default:null
    }, 
    setting: {
      type: Object,
      default: () => {}
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
  },
  data(){
    return {
      isWeb: true,
      tipPopupShow: false,
    }
  },
  methods: {
    // 登录传参
    onChangePop(val) {
      let eventName = 'LS_PC_H_Login';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_H_Login';
      }

      this.common.googleEvent(eventName, {
          '触发位置': '比赛内页O/U'
      });

      let _val = val;
      this.$emit('onChangLogin', _val);
    },

    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },

    // 获取百分比
    percentageVal(a,b,num){
      if(a && b){
        return (((b/a) * 100).toFixed(num||0) || 0) + '%'
      }else{
        return '0%'
      }
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },

    changePup(type){
      this.$emit('changePup',type)
    },

    // 关联比赛
    changeMatch(item){
      let eventName = 'LS_PC_MD_AdditionalMatches_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_AdditionalMatches_Click';
      }
      this.common.googleEvent(eventName, {
        '玩法': this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][2]
      });

      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    showPopup(){
      if(!this.tipPopupShow){
        let eventName = 'LS_PC_Help_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_Help_Click';
        }

        this.common.googleEvent(eventName, {
            '点击位置': '比赛内页O/U'
        });
      }

      this.tipPopupShow = true
    },
  },
  mounted() {
    let eventName = 'LS_PC_MD_O';
    if(this.common.isMobile != 4){
        eventName = 'LS_Webapp_MD_O';
    }
    this.common.googleEvent(eventName);

    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
}
</script>
<style scoped lang="less"> 
  @import 'overunder.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/overunder.vue